import { createSlice } from '@reduxjs/toolkit'
import { setWith } from 'lodash-es'
import Status from '@constants/request_statuses.ts'
import { saveEntity, deleteEntity } from '../actions/ClientActions.js'

export const initialState = {
  requests: {},
  deleteRequests: {},
}

/**
 * Redux slice for managing entity saving and deletion requests.
 */
const entitySaver = createSlice({
  name: 'entitySaver',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(saveEntity.pending, (state, action) => {
        const { type, id } = action.meta.arg
        const idString = id.toString()
        const lowerCaseType = type.toLowerCase()
        setWith(state, ['requests', lowerCaseType, idString, 'status'], Status.LOADING, Object)
        setWith(state, ['requests', lowerCaseType, idString, 'error'], null, Object)
      })
      .addCase(saveEntity.fulfilled, (state, action) => {
        const { type, id } = action.meta.arg
        const idString = id.toString()
        const lowerCaseType = type.toLowerCase()
        setWith(state, ['requests', lowerCaseType, idString, 'status'], Status.SUCCEEDED, Object)
        setWith(state, ['requests', lowerCaseType, idString, 'error'], null, Object)
      })
      .addCase(saveEntity.rejected, (state, action) => {
        const { type, id } = action.meta.arg
        const idString = id.toString()
        const lowerCaseType = type.toLowerCase()
        setWith(state, ['requests', lowerCaseType, idString, 'status'], Status.FAILED, Object)
        setWith(state, ['requests', lowerCaseType, idString, 'error'], action.payload, Object)
      })
      .addCase(deleteEntity.pending, (state, action) => {
        const { type, id } = action.meta.arg
        const idString = id.toString()
        const lowerCaseType = type.toLowerCase()
        setWith(state, ['requests', lowerCaseType, idString, 'status'], Status.LOADING, Object)
        setWith(state, ['requests', lowerCaseType, idString, 'error'], null, Object)
      })
      .addCase(deleteEntity.fulfilled, (state, action) => {
        const { type, id } = action.meta.arg
        const idString = id.toString()
        const lowerCaseType = type.toLowerCase()
        setWith(state, ['requests', lowerCaseType, idString, 'status'], Status.SUCCEEDED, Object)
        setWith(state, ['requests', lowerCaseType, idString, 'error'], null, Object)
      })
      .addCase(deleteEntity.rejected, (state, action) => {
        const { type, id } = action.meta.arg
        const idString = id.toString()
        const lowerCaseType = type.toLowerCase()
        setWith(state, ['requests', lowerCaseType, idString, 'status'], Status.FAILED, Object)
        setWith(state, ['requests', lowerCaseType, idString, 'error'], action.payload, Object)
      })
  },
})

// selectors

const getBase = state => state.entitySaver

const selectEntityRequestStatus = (state, props) => {
  const { id, type } = props
  const idString = id.toString()
  const lowerCaseType = type.toLowerCase()
  return getBase(state)?.requests?.[lowerCaseType]?.[idString]?.status
}
const selectEntityRequestError = (state, props) => {
  const { id, type } = props
  const idString = id.toString()
  const lowerCaseType = type.toLowerCase()
  return getBase(state)?.requests?.[lowerCaseType]?.[idString]?.error
}

export const selectors = {
  selectEntityRequestStatus,
  selectEntityRequestError,
}

export default entitySaver.reducer
